export default __webpack_public_path__ + "static/media/resent_invite.1d4ee66d.svg";